import React, { Component } from 'react';
import { Field, reduxForm, hasSubmitFailed, SubmissionError, getFormMeta } from 'redux-form';
import { Row, Grid, FormGroup, Checkbox, Alert, Col } from 'react-bootstrap';
import { connect } from 'react-redux';

const validate = (values, props) => {
  const errors = {};
  // if (!values.acceptRules && props.fields && props.fields.acceptRules && props.fields.acceptRules.visited) {
  //   errors._error = { message: 'You need to accept terms to proceed' };
  // }
  // if (!values.acceptTerms && props.fields && props.fields.acceptTerms && props.fields.acceptTerms.visited) {
  //   errors._error = { message: 'You need to accept terms to proceed' };
  // }
  // if (!values.acceptRules && !values.acceptRules) errors.acceptRules = 'Required';
  // if (!values.acceptTerms && !values.acceptTerms) errors.acceptTerms = 'Required';

  return errors;
};

const warn = values => {
  const warnings = {};
  if (values.age < 19) {
    warnings.age = 'Hmm, you seem a bit young...';
  }
  return warnings;
};

const renderField = ({ input, label, type, meta: { touched, error, warning } }) => {
  // if (touched && error) {
  //   SubmissionError({
  //     _error: { message: 'You need to accept terms to proceed' }
  //   });
  // }
  return (
    <div>
      <Checkbox {...input} type={type} style={{ position: '' }}>
        {label}
      </Checkbox>
    </div>
  );
};

class SyncValidationForm extends Component {
  render() {
    const { handleSubmit, error, anyTouched } = this.props;
    return (
      <Grid>
        <Row>
          <form onSubmit={handleSubmit} className="form">
            <FormGroup>
              <Field
                name="acceptRules"
                type="checkbox"
                component={renderField}
                label="I accept the rules of the transfer types and confirm that my booking details are correct"
              />
              <Field
                name="acceptTerms"
                type="checkbox"
                component={renderField}
                label={
                  <span>
                    I accept the Ski-Lifts{' '}
                    <a href="https://www.ski-lifts.com/terms/" target="_blank" rel="noopener noreferrer">
                      Booking Conditions
                    </a>,{' '}
                    <a href="https://www.ski-lifts.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
                      Website Terms of Use
                    </a>{' '}
                    and{' '}
                    <a href="https://www.ski-lifts.com/privacy/" target="_blank" rel="noopener noreferrer">
                      Privacy Policy
                    </a>
                  </span>
                }
              />
              <Field
                name="receiveEmails"
                type="checkbox"
                component={renderField}
                label="I'm happy for Ski-Lifts or Sea-Lifts to send the occasional email to the Lead Passenger email address"
              />
            </FormGroup>
          </form>
          {/* {this.props.submitFailed ? <Alert bsStyle="warning">You need to accept terms to proceed</Alert> : null} */}
          {anyTouched &&
            error && (
              <Row className="container continueMessage">
                <Col>
                  <Alert bsStyle="success">
                    {error.title ? <h4>{error.title}</h4> : null}
                    <p
                      dangerouslySetInnerHTML={{
                        __html: error.message
                      }}
                    />
                  </Alert>
                </Col>
              </Row>
            )}
        </Row>
      </Grid>
    );
  }
}

SyncValidationForm = reduxForm({
  enableReinitialize: false,
  keepDirtyOnReinitialize: true,
  onSubmit: (val, dispatch, props) => {
    if (!val.acceptRules || !val.acceptTerms) {
      throw new SubmissionError({ _error: { message: 'You need to accept terms to proceed' } });
    }
    return props.confirmBooking(props.id, val).then(res => {
      return props.proceedStep(props.id, 'payment').then(res => {

        if (res.data.basket.continueText.show) {
          throw new SubmissionError({
            _error: res.data.basket.continueText
          });
        }
      });
    });
  },
  onSubmitFail: errors => {}, //console.log(errors),
  form: 'terms', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  warn // <--- warning function given to redux-form
})(SyncValidationForm);

export default connect(
  state => ({
    submitFailed: hasSubmitFailed('terms')(state),
    fields: getFormMeta('terms')(state)
  }),
  null
)(SyncValidationForm);



// WEBPACK FOOTER //
// ./src/containers/ConfirmPage/Terms/Form/index.js